export const LIST_CORPORATE = 'List_Corporate';
export const LIST_CORPORATE_SUCCESS = 'List_Corporate_Success';
export const LIST_CORPORATE_FAILURE = 'List_Corporate_Failure';
export const FETCH_CORPORATE_CASE_COUNT = "Fetch_Corporate_Case_count"
export const FETCH_CORPORATE_CASE_COUNT_SUCCESS = "Fetch_Corporate_Case_count_Success"
export const FETCH_CORPORATE_CASE_COUNT_FAILURE = "Fetch_Corporate_Case_count_Failure"

export const listCorporate = () => {
    return {
        type: LIST_CORPORATE,
    }
}

export const listCorporateSuccess = (data) => {
    return {
        type: LIST_CORPORATE_SUCCESS,
        data
    }
}

export const listCorporateFailure = (error) => {
    return {
        type: LIST_CORPORATE_FAILURE,
        error
    }
}

export const fetchCorporateCaseCount = (data) => {
    return {
        type: FETCH_CORPORATE_CASE_COUNT,
        data
    }
}

export const fetchCorporateCaseCountSuccess = (data) => {
    return {
        type: FETCH_CORPORATE_CASE_COUNT_SUCCESS,
        data
    }
}

export const fetchCorporateCaseCountFailure = (data) => {
    return {
        type: FETCH_CORPORATE_CASE_COUNT_FAILURE,
        data
    }
}